import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { CustomerForm } from "@/features/dashboard/clientes/components/CustomerForm";

export const Route = createFileRoute("/_private/dashboard/_base/clientes/cadastrar/modal")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <BaseEditCreateModal title="Cadastrar Cliente" from="/dashboard/clientes/cadastrar">
      <CustomerForm />
    </BaseEditCreateModal>
  );
}
